<template>
  <div class="richtext text-common-styles">
    <slot />
  </div>
</template>

<style lang="css">
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

/* These unscoped styles are needed for rich text editor & display to work properly */
.richtext {
  /* .ck-content lists repeat the selectors to outrank the CKEditor content styles, which set list markers. */
  ul,
  .ck-content ul {
    @apply list-none pl-0;

    li {
      @apply relative pl-8 before:absolute before:top-3 before:left-0 before:h-0.5 before:w-[14px] before:bg-black;
    }
  }

  ol,
  .ck-content ol {
    @apply list-none pl-0 [counter-reset:list-counter];

    li {
      @apply relative mb-2 pl-8 [counter-increment:list-counter] before:absolute before:top-0 before:left-0 before:content-[counter(list-counter)_"._"];
    }
  }
}
</style>
